"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const groupActions = new _index.JoinActionHelper("user", "group");
const permissionActions = new _index.JoinActionHelper("user", "permission");
const licenseActions = new _index.JoinActionHelper("user", "license");
const pictureActions = new _index.ActionHelper({
  singular: "userimage"
});
const userActions = new _index.ActionHelper({
  singular: "user"
});
class Actions extends _index.ActionHelper {
  constructor() {
    super({
      singular: "user",
      plural: "users"
    });
    _defineProperty(this, "addGroup", body => groupActions.create(body, {
      expand: "Group"
    }, this));
    _defineProperty(this, "dropGroup", id => groupActions.destroy(id, this));
    _defineProperty(this, "addLicense", body => licenseActions.create(body, {
      expand: "License"
    }, this));
    _defineProperty(this, "dropLicense", licenseActions.destroy);
    _defineProperty(this, "addPermission", body => permissionActions.create(body, {
      expand: "Permission"
    }, this));
    _defineProperty(this, "dropPermission", permissionActions.destroy);
    _defineProperty(this, "addPicture", pictureActions.create);
    _defineProperty(this, "updatePicture", pictureActions.update);
    _defineProperty(this, "dropPicture", pictureActions.destroy);
    _defineProperty(this, "updateUser", userActions.update);
    _defineProperty(this, "get", (id, params, module) => userActions.get(id, params, this));
    _defineProperty(this, "getAll", (params, module) => userActions.getAll(params, this));
    _defineProperty(this, "init", data => {
      if (data && data.schema && data.schema.UserImage && data.schema.UserImage.visible === false) {
        this.state.areUserImagesShown = false;
      }
      return dispatch => {
        dispatch({
          type: "INIT_USERS",
          data: data
        });
      };
    });
    /* If the images are visible, the "UserImage" expand is added to the request */
    _defineProperty(this, "preGet", (request, id, params) => {
      if (this.state.areUserImagesShown === true) {
        params.expand += ",UserImage";
      }
      request.url = `${this._uri}/${id}${(0, _index.paramsToString)(params)}`;
      return request;
    });
    _defineProperty(this, "isAdminUser", () => {
      let adminLicenseId = "039d6fdd-53c2-408a-b924-f07505d15a34";
      return (0, _index.createRequest)(true).then(request => {
        request.method = "get";
        request.url = "/users/me?expand=UserLicenses";
        return (0, _index.sendRequest)(request).then(response => {
          for (let license of response.data.UserLicenses) {
            if (license.LicenseId === adminLicenseId) return true;else return false;
          }
        }).catch(error => {
          console.dir(error);
        });
      }).catch(error => {
        console.dir(error);
      });
    });
    /* We check which users have a UserImageId and request the images one by one */
    _defineProperty(this, "postGetAll", (response, dispatch, useAuthentication, cancelToken = undefined) => {
      if (this.state.areUserImagesShown === false) {
        return null;
      }
      response.data.reduce((promise, user) => {
        if (!user.UserImageId) {
          return Promise.resolve();
        }
        dispatch({
          type: "GET_IMAGE_REQUEST"
        });
        return promise.then(() => {
          return (0, _index.createRequest)(useAuthentication, cancelToken).then(request => {
            request.method = "get";
            request.url = `userimages?filter=UserId="${user.Id}"`;
            request.cancelToken = cancelToken.token;
            return (0, _index.sendRequest)(request, useAuthentication).then(response => {
              if (response.data.length > 0) {
                let dataSent = response.data[0];
                dispatch({
                  type: "GET_IMAGE_SUCCESS",
                  data: dataSent
                });
                return response;
              }
            }).catch(error => {
              if (_axios.default.isCancel(error)) {
                return response;
              } else {
                console.dir(error);
                dispatch({
                  type: "GET_IMAGE_FAILURE",
                  data: error.response ? error.response.data : {
                    Message: "An error occurred."
                  }
                });
                return response;
              }
            });
          });
        });
      }, Promise.resolve());
    });
    this.state = {
      areUserImagesShown: true
    };
  }
  /*
  We don't want to show the "Guest" users in the userlist, so we filter them out.
  We also don't show "Developer" users if the user has an Admin license. This is
  because they are not allowed to see developer licenses and the userlist breaks.
  */

  async preGetAll(getAllRequest, params) {
    if (params.filter) params.filter += " and ";
    let guestUserName = "Guest";
    let developerLicenseId = "91f2e5b9-5149-455d-b5d3-339f6de344db";
    let adminUser = await this.isAdminUser();
    if (adminUser === true) {
      params.filter += `not Type.Equals("${guestUserName}") and UserLicenses.Any(x => x.LicenseId <> "${developerLicenseId}")`;
      getAllRequest.url = `${this._uri}${(0, _index.paramsToString)(params)}`;
      return getAllRequest;
    } else if (adminUser === false) {
      params.filter += `not Type.Equals("${guestUserName}") `;
      getAllRequest.url = `${this._uri}${(0, _index.paramsToString)(params)}`;
      return getAllRequest;
    }
    return adminUser;
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;